<script>
	export let data;

	function getPopularBlogs() {
		if (data.length == 0) {
			return;
		} else if (data.length == 1) {
			return [data[0]];
		} else {
			return [data[data.length - 1], data[data.length - 2]];
		}
	}

	export let showMore = false;
	export let skipBlog = 0;

	let showBlogs = false;

	if (showMore == true) {
		showBlogs = true;
	}

	let limit = 2;

	function formatUrl(scale, img_id) {
		let formatedUrl = `${import.meta.env.VITE_API_URL}/communitychronicle/image/${img_id}?scaley=${scale}&encoding=webp`;
		return formatedUrl;
	}

	function handleEncodeCaracters(s) {
		return s.replace(/&#8217;/g, "'");
	}
</script>

{#if showMore == false}
	{#each getPopularBlogs() as popularBlog, counter}
		{#if popularBlog.published == true}
			{#if counter <= limit}
				<a href="{import.meta.env.VITE_URL}/communitychronicle/{popularBlog.slug}">
					<div class="popular-card">
						<div>
							<img src="{formatUrl(90, popularBlog.blog_images[0].id)}" alt="" />
							<h1>{handleEncodeCaracters(popularBlog.subject)}</h1>
						</div>
					</div>
				</a>
			{/if}
		{/if}
	{/each}
{/if}

<div class:show-more={!showBlogs}>
	{#each data as popularBlog, i}
		{#if i < data.length - 2 && showMore == false && popularBlog.published == true && i <= limit}
			<a href="{import.meta.env.VITE_URL}/communitychronicle/{popularBlog.slug}">
				<div class="popular-card">
					<div>
						<img src="{formatUrl(90, popularBlog.blog_images[0].id)}" alt="" />
						<h1>{popularBlog.subject}</h1>
					</div>
				</div>
			</a>
		{:else if showMore == true && popularBlog.id != skipBlog && popularBlog.published == true && i <= limit}
			<a href="{import.meta.env.VITE_URL}/communitychronicle/{popularBlog.slug}">
				<div class="popular-card">
					<div>
						<img src="{formatUrl(90, popularBlog.blog_images[0].id)}" alt="" />
						<h1>{popularBlog.subject}</h1>
					</div>
				</div>
			</a>
		{/if}
	{/each}
</div>
{#if showMore == false}
	<button on:click={() => (showBlogs = !showBlogs)}>View All Articles</button>
{/if}

<style>
	.show-more {
		display: none !important;
	}

	button {
		all: unset;
		cursor: pointer;
		font-weight: 600;
		line-height: 22px;
		color: #10b5d9;
		text-decoration: underline;
	}
	.popular-card {
		border-radius: 20px;
		background: #ffffff;
		width: 360px;
		height: fit-content;
		margin-bottom: 24px;
		filter: drop-shadow(0px 10px 10px rgba(0, 0, 0, 0.1));
	}
	.popular-card div {
		display: flex;
	}

	.popular-card img {
		margin: 13px 0;
		width: 132px;
		border-radius: 10px;
		margin-left: 13px;
		margin-right: 12px;
	}

	.popular-card h1 {
		font-weight: 700;
		font-size: 17px;
		line-height: 19px;
	}

	a {
		all: unset;
		cursor: pointer;
	}

	@media only screen and (max-width: 1202px) {
		.popular-card {
			width: 100%;
		}
	}
</style>
